import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'

export enum DriverBreakReasonType {
  AdHocBreak = 'adHocBreak',
  Break = 'break',
  DeviceIssue = 'deviceIssue',
  DoorToDoor = 'doorToDoor',
  DriverDAndATesting = 'driverDAndATesting',
  DriverMedical = 'driverMedical',
  DriverMisconduct = 'driverMisconduct',
  DriverUnionBusiness = 'driverUnionBusiness',
  LocationClosed = 'locationClosed',
  LocationIncorrect = 'locationIncorrect',
  Other = 'other',
  RiderBiohazard = 'riderBiohazard',
  RiderDisorderly = 'riderDisorderly',
  RiderMedical = 'riderMedical',
  RiderNonpayment = 'riderNonpayment',
  VehicleAccident = 'vehicleAccident',
  VehicleBreakdown = 'vehicleBreakdown',
  VehicleCharging = 'vehicleCharging',
  VehicleFueling = 'vehicleFueling',
  VehicleMaintenance = 'vehicleMaintenance',
}

export const DRIVER_BREAK_REASON_DEFAULTS: Record<
  DriverBreakReasonType,
  { includeInRevenueMetrics: boolean; includeInVehicleMetrics: boolean }
> = {
  [DriverBreakReasonType.AdHocBreak]: { includeInRevenueMetrics: false, includeInVehicleMetrics: false },
  [DriverBreakReasonType.Break]: { includeInRevenueMetrics: false, includeInVehicleMetrics: false },
  [DriverBreakReasonType.DeviceIssue]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.DoorToDoor]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.DriverDAndATesting]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.DriverMedical]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.DriverMisconduct]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.DriverUnionBusiness]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.LocationClosed]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.LocationIncorrect]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.Other]: { includeInRevenueMetrics: false, includeInVehicleMetrics: false },
  [DriverBreakReasonType.RiderBiohazard]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.RiderDisorderly]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.RiderMedical]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.RiderNonpayment]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.VehicleAccident]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.VehicleBreakdown]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.VehicleCharging]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.VehicleFueling]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
  [DriverBreakReasonType.VehicleMaintenance]: { includeInRevenueMetrics: true, includeInVehicleMetrics: true },
}

export interface IDriverBreakReasonResponse extends IModelJsonValues {
  type: DriverBreakReasonType
  includeInRevenueMetrics: boolean
  includeInVehicleMetrics: boolean
  isArchived?: boolean
}
export interface IDriverBreakReasonListQueryParams extends IListModelQueryParamValues {
  isArchived?: boolean
}

export type IDriverBreakReasonPostBody = Pick<
  IDriverBreakReasonResponse,
  'type' | 'includeInRevenueMetrics' | 'includeInVehicleMetrics'
>
export type IDriverBreakReasonPatchBody = Partial<IDriverBreakReasonPostBody> & {
  isArchived?: boolean
}
